import { render, staticRenderFns } from "./RecoverSuccessModal.vue?vue&type=template&id=7bd9e8aa&"
import script from "./RecoverSuccessModal.vue?vue&type=script&lang=js&"
export * from "./RecoverSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports